import React from 'react';
import classnames from 'classnames';

export default function LocationMarker({location, isInSearchResults}) {
  const {id, name, address, city, state, zipcode, slug, listing_count} = location;

  return (
    <div className={classnames("marker", {"has-listings": listing_count > 0, "in-results": isInSearchResults})}>
      <div className="marker-overlay">
        <div className="tooltip-wrapper">
          <a href={`/organizations/${slug}`} title={name} className="listing-tooltip">
            <div className="available">
              <h4>{listing_count}</h4>
              Equines Available
            </div>
            <div className="tooltip-name">
              <h4>{name}</h4>
              {address}
              <br/>
              {city}, {state} {zipcode}
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}
